export default __webpack_public_path__ + "static/reviewer-d02add018ad2568d420c405a21e928f1.png";